<div class="row">
  <div class="col">
    <div class="container-fluid pl-0 info-list has-info-icon height-unset">
      <h3 class="sub-title">
        Traffic Overview
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
           data-animation="false"
           title="App Traffic Statistics and Risk Factors">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon"/>
        </a>
      </h3>
    </div>
  </div>
</div>
<app-traffic-overview [data]="data"
                      [isFollowing]="isFollowing"
                      [isFreemium]="isFreemium"
                      (anchorClick)="goToSection($event)"
></app-traffic-overview>
<app-follow-unlock label="Additional IVT Risks"
                   (followClick)="follow()"
                   *ngIf="!isFollowing && isFreemium"
></app-follow-unlock>

<ng-container *ngIf="byOverallStats?.length > 0">
  <div class="row">
    <div class="col-lg-12">
      <div class="container-fluid pl-0 info-list has-info-icon height-unset mt-32px">
        <h3 class="sub-title">
          Overall Traffic Overlap Trends
        </h3>
      </div>
    </div>
  </div>
  <app-data-table-component [headers]="headers" minWidth="650px"
                            [currentSort]="'impOverlapRate'"
                            [limit]="isFreemium ? 5 : 10"
                            [data]="byOverallStats"
                            [maxValueMapping]="byOverallMaxValueMapping"
  ></app-data-table-component>
</ng-container>

<ng-container *ngIf="byIvtStats?.length > 0">
  <div class="row">
    <div class="col-lg-12">
      <div class="container-fluid pl-0 info-list has-info-icon height-unset mt-32px">
        <h3 class="sub-title">
          Traffic Overlap Trends by IVT
        </h3>
      </div>
    </div>
  </div>
  <app-data-table-component [headers]="headers" minWidth="650px"
                            [currentSort]="'impOverlapRate'"
                            [limit]="isFreemium ? 5 : 10"
                            [data]="byIvtStats"
                            [maxValueMapping]="byIvtMaxValueMapping"
  ></app-data-table-component>
</ng-container>

<ng-template #titleTemplate let-item='item' let-row='row'>
  <div class='d-flex align-items-center'>
    <ng-container *ngIf='row.icon !== "N/A"'>
      <div><img class="app-icon" src="{{row.icon}}" alt="App Icon"/></div>
    </ng-container>
    <ng-container *ngIf='row.icon === "N/A"'>
      <div><img class="app-icon" src="/assets/images/logo-grey-16x16.png" alt="Grey Logo" width="16" height="16"/></div>
    </ng-container>

    <div class="ml-2 overflow-hidden">
      <div class="app-title">{{item}}</div>
      <ng-container *ngIf='!isFreemium'>
        <risk-heat-meter [risk]='row.risk'></risk-heat-meter>
      </ng-container>
      <ng-container *ngIf='isFreemium'>
        <div class="freemium-lock"><i class="fa fa-lock"></i></div>
      </ng-container>
    </div>
  </div>
</ng-template>
